import styled from 'styled-components'
import ShowMoreIconImage from '../../../assets/icons/chevron-down.svg'
import CloseIcon from '../../../assets/icons/close.svg'

export const StyledCloseIcon = styled(CloseIcon)`
    width: 1.4rem;
    height: 1.4rem;
    transition: transform 0.2s ease-in-out;
    stroke: #282828;
    stroke-width: 1px;
    cursor: pointer;
    &:hover {
        transform: scale(1.2);
    }
`

export const ExposeMobileWrapper = styled.div`
    display: block;
    width: 100%;
    @media (min-width: 570px) {
        display: none;
    }
`

export const ExposeDesktopWrapper = styled.div`
    display: none;
    @media (min-width: 570px) {
        display: block;
        width: 100%;
    }
`

export const EntitySectionContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-top: 0.5rem;
`

export const ChooseDate = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`

export const ObjectSeparatorMobile = styled.div`
    height: 0.0625rem;
    margin: 0.5rem 0;
    background-image: linear-gradient(to right, #d3d3d3 30%, transparent 0%);
    background-size: 0.094rem 0.0625rem;
    background-repeat: repeat-x;
`

export const ObjectSeparatorDesktop = styled.div`
    padding: 0.25rem 0;
`

export const ShowMoreButton = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 0.5rem;
    gap: 0.5rem;
    cursor: pointer;
`

export const ShowMoreIcon = styled(ShowMoreIconImage)`
    width: 0.625rem;
    height: 0.625rem;
    path {
        fill: #006ddb;
        stroke: #006ddb;
        stroke-width: 3;
    }
`
